// Common coordinates for Tromsø area
export const TROMSO_CENTER: [number, number] = [69.6492, 18.9553];
export const TROMSO_FJORD: [number, number] = [69.7085, 19.0409];

// Mock data for TrailsMap
export const mockTrails = [
  {
    id: '1',
    name: 'Classic Whale Safari Route',
    description: 'Primary winter route for whale watching tours',
    difficulty: 'moderate',
    distance: 12.5, // in kilometers
    coordinates: [
      [69.6492, 18.9553], // Tromsø harbor
      [69.7085, 19.0409], // Fjord entry
      [69.7245, 19.0876], // Common whale feeding area
      [69.7123, 19.0532]  // Return route
    ],
    points: [
      {
        id: 'p1',
        name: 'Orca Feeding Ground',
        type: 'wildlife',
        coordinates: [69.7245, 19.0876],
        description: 'Common area for orca pod sightings during herring season'
      },
      {
        id: 'p2',
        name: 'Humpback Rest Area',
        type: 'wildlife',
        coordinates: [69.7123, 19.0532],
        description: 'Frequent humpback whale sightings in winter'
      }
    ],
    color: '#2C5F2D'
  },
  {
    id: '2',
    name: 'Orca Snorkeling Route',
    description: 'Specialized route for orca encounters and snorkeling',
    difficulty: 'difficult',
    distance: 8.0,
    coordinates: [
      [69.6492, 18.9553],
      [69.6998, 19.0234],
      [69.7123, 19.0532]
    ],
    points: [
      {
        id: 'p3',
        name: 'Snorkeling Point Alpha',
        type: 'facility',
        coordinates: [69.6998, 19.0234],
        description: 'Primary snorkeling location with safety boat'
      }
    ],
    color: '#97BC62'
  }
];

// Mock data for LiveTracking
export const mockTourGroups = [
  {
    id: '1',
    name: 'Morning Whale Safari',
    guide: 'Erik Hansen',
    size: 12,
    location: [69.7085, 19.0409],
    status: 'active',
    startTime: new Date().toISOString(),
    duration: 180,
    trail: 'Classic Whale Safari Route',
    lastUpdate: new Date().toISOString()
  },
  {
    id: '2',
    name: 'Orca Snorkeling Adventure',
    guide: 'Maria Nilsen',
    size: 6,
    location: [69.6998, 19.0234],
    status: 'active',
    startTime: new Date().toISOString(),
    duration: 240,
    trail: 'Orca Snorkeling Route',
    lastUpdate: new Date().toISOString()
  }
];

export const mockVehicles = [
  {
    id: '1',
    name: 'Arctic Queen',
    type: 'boat',
    driver: 'Captain Erik Hansen',
    location: [69.7085, 19.0409],
    status: 'active',
    speed: 12,
    fuel: 85,
    lastUpdate: new Date().toISOString()
  },
  {
    id: '2',
    name: 'Orca Explorer',
    type: 'boat',
    driver: 'Captain Maria Nilsen',
    location: [69.6998, 19.0234],
    status: 'active',
    speed: 8,
    fuel: 92,
    lastUpdate: new Date().toISOString()
  }
];

// Mock data for WildlifeSightings
export const mockSightings = [
  {
    id: '1',
    species: 'Orca Pod',
    count: 6,
    location: [69.7245, 19.0876],
    timestamp: new Date().toISOString(),
    reportedBy: 'Arctic Queen Crew',
    status: 'verified',
    notes: 'Pod including 2 calves, hunting herring',
    behavior: 'hunting'
  },
  {
    id: '2',
    species: 'Humpback Whale',
    count: 2,
    location: [69.7123, 19.0532],
    timestamp: new Date().toISOString(),
    reportedBy: 'Orca Explorer Crew',
    status: 'verified',
    notes: 'Breaching activity observed',
    behavior: 'breaching'
  },
  {
    id: '3',
    species: 'Sperm Whale',
    count: 1,
    location: [69.6998, 19.0234],
    timestamp: new Date().toISOString(),
    reportedBy: 'Marine Biologist Anna',
    status: 'rare',
    notes: 'Deep diving behavior, typical of feeding',
    behavior: 'feeding'
  }
];

// Mock data for MapSettings
export const defaultMapSettings = {
  defaultCenter: TROMSO_CENTER,
  defaultZoom: 12,
  mapProvider: 'osm',
  showLegend: true,
  showScale: true,
  showCompass: true,
  trackingInterval: 30,
  heatmapRadius: 50, // Larger radius for whale movements
  maxZoom: 16,
  minZoom: 10
};